


















import {
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';

import CollectInfo from '@/renderer/views/common/collect/components/CollectInfo.vue';
import CollectFile from '@/renderer/views/common/collect/components/CollectFile.vue';
import headbar from '@/renderer/views/desktop/headbar/index.vue';
import Login from '@/renderer/components/login/components/index.vue';
import UserAvatar from '@/renderer/components/user/components/userAvatar.vue';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import { OrgLogoInfo } from '@/renderer/scripts/libs/smh-sdk-class/typings';

export interface InviteTitleData {
  type: string;
  title: string;
}

export default defineComponent({
  name: 'CollectView',
  components: { CollectFile, CollectInfo, headbar, Login, UserAvatar },
  setup(_, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const isLogined = computed(() => vm.$store.getters.isLogined || vm.$store.getters.isVistorLogined);
    const isVistor = ref(false);
    const collectToken = computed(() => vm.$route.params?.collectToken);
    const inviteTitle = reactive<InviteTitleData>({
      type: '',
      title: '',
    });
    const orgLogoInfo = reactive<OrgLogoInfo>({
      orgLogo: '',
      orgName: '',
      showOrgNameInUI: undefined,
    });

    // 收集文件登录页面
    const methods = {
      setOrgLogoInfo(logoInfo: OrgLogoInfo) {
        Object.assign(orgLogoInfo, logoInfo);
      },
      // 页面初始化过程
      // 页面加载可能2种情况
      //   1. 第一次加载 无登录态
      //  2. 第二次加载 有cookie记忆登录的 collectToken 和 collectUserToken
      showLoginDialog(way?: string) {
        // @ts-ignore
        const loginRef = vm.$refs.headbar?.$children[0];
        loginRef.showLogin = true;
        if (way === 'vistor') {
          loginRef.vistorLogin = true;
        }
      },
      hideLoginFun() {
        // @ts-ignore
        const loginRef = vm.$refs.headbar?.$children[0];
        loginRef.showLogin = false;
      },
      // 内部用户登录之后
      async logined() {
        // todo
      },
      // 自定义头部标题
      setInviteTitle(inviteTitleData: InviteTitleData) {
        Object.assign(inviteTitle, inviteTitleData);
      },
    };
    user.on('logined', methods.logined);

    watch(
      () => vm.$store.getters.isMobileStyle,
      newVal => {
        if (!vm.$store.getters.isMobileStyle) {
          Object.assign(inviteTitle, { type: '', title: '' });
        }
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.hideLoginFun);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.hideLoginFun);
      user.off('logined', methods.logined);
    });
    return {
      collectToken,
      isLogined,
      isVistor,
      inviteTitle,
      orgLogoInfo,
      ...methods,
    };
  },
});
